export default __webpack_public_path__ + "static/media/Mass_01.73d70d59.png";